import React from 'react'
import { ErrorMessage, Field, Form, Formik, FormikActions } from 'formik'
import * as Yup from 'yup'
import loadingBox from '../../assets/images/loading_box.gif'
import { Link } from 'react-router-dom'
import { ITSError } from '../Layout/ITSError'

interface LoginFormValues {
  username: string
  password: string
}

const LoginFormValidationSchema = Yup.object().shape({
  username: Yup.string()
    .email('Email is not valid')
    .required('Email is required'),
  password: Yup.string().required('Password is required'),
})

interface Props {
  handleLogin: (username: string, password: string) => Promise<any>
}

export const Login: React.FunctionComponent<Props> = props => {
  const loginFormInitialValues: LoginFormValues = {
    username: '',
    password: '',
  }

  const handleSubmit = (values: LoginFormValues, actions: FormikActions<LoginFormValues>) => {
    props.handleLogin(values.username, values.password).catch(() => {
      actions.setSubmitting(false)
    })
  }

  return (
    <>
      <div className="panel-heading">Login</div>
      <div className="panel-body">
        <Formik
          initialValues={loginFormInitialValues}
          validationSchema={LoginFormValidationSchema}
          onSubmit={handleSubmit}
          render={({ isValid, isSubmitting }) => (
            <Form>
              <label htmlFor="username" className="control-label">
                Email Address
              </label>
              <Field id="username" type="email" name="username" placeholder="Email" className="form-control dw-input" />
              <ErrorMessage name="username" render={errorMessage => <ITSError errorMessage={errorMessage} />} />
              <label htmlFor="password" className="control-label">
                Password
              </label>
              <Field
                id="password"
                type="password"
                name="password"
                placeholder="Password"
                className="form-control dw-input"
              />
              <ErrorMessage name="password" render={errorMessage => <ITSError errorMessage={errorMessage} />} />
              {!isSubmitting ? (
                <button type="submit" className="btn btn-default dw-btn" id="Login-btn" disabled={!isValid}>
                  Log in
                </button>
              ) : (
                <img src={loadingBox} className="loading" alt="loading" />
              )}
            </Form>
          )}
        />
        <Link to="/forgot-password" className="forgot-link">
          Forgot your password?
        </Link>
      </div>
    </>
  )
}
